import { ADMIN_PROFILE } from "../../../components/common/api";
import { axiosInstance } from "../../../components/common/interceptor";
import {
  fetchProfileFailure,
  fetchProfileSuccess,
  fetchProfileStart,
  editProfileFailure,
  editProfileSuccess,
  editProfileStart,
} from "../../reducer/AdminProfile/AdminProfileReducer";

// ............. Get Profile Details.................
let isGetAdminProfile = false;
export const GetProfileDetails = () => async (dispatch) => {
  if (isGetAdminProfile) return;
  isGetAdminProfile = true;
  dispatch(fetchProfileStart());
  try {
    const response = await axiosInstance.get(`${ADMIN_PROFILE}`);

    if (response.status !== 200) {
      throw new Error("Failed to fetch inspector details.");
    }
    dispatch(fetchProfileSuccess(response?.data));
  } catch (error) {
    console.error("Error fetching details:", error);
    dispatch(fetchProfileFailure(error.message));
  } finally {
    isGetAdminProfile = false;
  }
};


//  ................. Edit Profile ................

 let isEditAdminProfile = false;
export const EditProfile = (formData) => async (dispatch) => {
  if (isEditAdminProfile) return;
  isEditAdminProfile = true;
  dispatch(editProfileStart());
  try {
    const response = await axiosInstance.put(`${ADMIN_PROFILE}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status !== 200) {
      throw new Error("Failed to update profile.");
    }
    dispatch(editProfileSuccess(response?.data?.result));
    return { success: true };
  } catch (error) {
    console.error("Error updating profile:", error);
    dispatch(
      editProfileFailure(error.response?.data?.message || error.message)
    );
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  } finally {
    isEditAdminProfile = false;
  }
};
